import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import Alert, { AlertType } from '../../../../Shared/components/Alert';
import LoadingSpinner from '../../../../Shared/components/LoadingSpinner';
import DataService from '../../../services/DataService';
import { ZdsContentReveal, ZdsDivider } from '@zig-design-system/ui-components-react';
import { Formats } from '../../../../Shared/Utility/FormatUtility';
import Translation from '../../../../Shared/components/Translation';
import SpecificationList from '../../Unit/Detail/SpecificationList';
import PageTitle from '../../../../Shared/Utility/PageTitle';
import { renderToString } from 'react-dom/server';
import BackButton from '../../Generic/Detail/BackButton';
import Images from '../../Generic/Detail/Images';
import Map from '../../Generic/Detail/Map';
import Node from '../../../../KnowledgeBase/components/Node';
import Reaction from '../../Complex/Detail/Reaction';
const ComplexDetail = () => {
    var _a;
    const { id } = useParams();
    const [complex, setComplex] = useState();
    const [errorStatus, setErrorStatus] = useState();
    useEffect(() => {
        window.scrollTo({ top: 0 });
        DataService.getComplexById(id)
            .then((complexResponse) => {
            setComplex(complexResponse);
        })
            .catch((err) => {
            setErrorStatus(err.status);
            setComplex(null);
        });
    }, [id]);
    useEffect(() => {
        if (complex === null || complex === void 0 ? void 0 : complex.name) {
            PageTitle.set(complex.name);
        }
    }, [complex]);
    if (complex === undefined) {
        return React.createElement(LoadingSpinner, null);
    }
    else if (!complex) {
        if (errorStatus === 404) {
            return (React.createElement(Alert, { title: "t(tx_zigrealestate.error.unitNotFound.title)", message: "t(tx_zigrealestate.error.unitNotFound.message)", type: AlertType.error }));
        }
        else {
            return (React.createElement(Alert, { title: "t(tx_zigrealestate.error.unitCallError.title)", message: "t(tx_zigrealestate.error.unitCallError.message)", type: AlertType.error }));
        }
    }
    const renderKnowledgeBase = () => {
        return (React.createElement("div", { className: "no-indentation default-content zds-margin-bottom-6" },
            React.createElement("h2", { className: "zds-headline-md zds-margin-bottom-2" },
                React.createElement(Translation, { item: "tx_zigrealestate.complex.knowledgeBaseHeader" })),
            React.createElement(Node, { startNodeId: complex.knowledgeBaseRootUid })));
    };
    return (React.createElement("div", { className: "zds-row zds-gap-y-0" },
        ((_a = complex.images) === null || _a === void 0 ? void 0 : _a.length) > 0 && React.createElement(Images, { images: complex.images }),
        React.createElement("div", { className: "default-content" },
            React.createElement("div", { className: "zds-margin-bottom-6" },
                React.createElement("h1", { className: "zds-headline-xxl" }, complex.name)),
            React.createElement(Reaction, { complex: complex }),
            React.createElement(ZdsDivider, { className: "zds-margin-y-4 md:zds-margin-y-8" }),
            complex.description && (React.createElement(React.Fragment, null,
                React.createElement("div", { className: "real-estate__property-group" },
                    React.createElement("dl", { className: "md:zds-flex" },
                        React.createElement("dt", null,
                            React.createElement("h2", { className: "zds-headline-md zds-margin-bottom-2" },
                                React.createElement(Translation, { item: "tx_zigrealestate.list.description" }))),
                        React.createElement("dd", null,
                            React.createElement("div", null,
                                React.createElement(ZdsContentReveal, { closedText: renderToString(React.createElement(Translation, { item: "tx_zigrealestate.readMore" })), openText: renderToString(React.createElement(Translation, { item: "tx_zigrealestate.less" })) },
                                    React.createElement("p", { dangerouslySetInnerHTML: { __html: complex.description } })))))),
                React.createElement(ZdsDivider, { className: "zds-margin-y-4 md:zds-margin-y-8" }))),
            React.createElement(SpecificationList, { bottomDivider: !(complex.latitude && complex.longitude), title: "tx_zigrealestate.list.properties", specifications: [
                    { key: 'tx_zigrealestate.street', value: complex.street },
                    { key: 'tx_zigrealestate.city', value: complex.city },
                    {
                        key: 'tx_zigrealestate_domain_model_rentableunit.postal_code',
                        value: complex.postalCode,
                        format: Formats.postalCode,
                    },
                ] })),
        React.createElement(Map, { latitude: complex.latitude, longitude: complex.longitude }),
        complex.knowledgeBaseRootUid && renderKnowledgeBase(),
        React.createElement("div", { className: "default-content" },
            React.createElement(BackButton, null))));
};
export default ComplexDetail;
